var React = require('react');

function Private (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M12.6,5.3h-0.8V3.8C11.8,1.7,10.1,0,8,0S4.2,1.7,4.2,3.8v1.5H3.4C2.5,5.3,1.8,6,1.8,6.9v7.6c0,0.8,0.7,1.5,1.5,1.5h9.2\n\tc0.8,0,1.5-0.7,1.5-1.5V6.9C14.2,6,13.5,5.3,12.6,5.3z M8,12.2c-0.8,0-1.5-0.7-1.5-1.5c0-0.8,0.7-1.5,1.5-1.5s1.5,0.7,1.5,1.5\n\tC9.5,11.5,8.8,12.2,8,12.2z M10.4,5.3H5.6V3.8c0-1.3,1.1-2.4,2.4-2.4s2.4,1.1,2.4,2.4V5.3z","fill":"currentColor"}));
}

Private.defaultProps = {"version":"1.1","id":"Layer_1","x":"0px","y":"0px","viewBox":"0 0 16 16","style":{"enableBackground":"new 0 0 16 16"},"xmlSpace":"preserve"};

module.exports = Private;

Private.default = Private;
